import { useChat } from "../../context/ChatContext";
import FloatingChat from "./FloatingChat";

const ChatManager = ({ rightOffset = 20 }) => {
  const { openChats, closeChat, toggleMinimize, sendMessage, driversStatus, loadMoreMessages } =
    useChat();

  return (
    <div
      style={{
        position: "fixed",
        bottom: "10px",
        right: `${rightOffset}px`,
        display: "flex",
        gap: "10px",
        zIndex: 1000,
        alignItems: "flex-end",
        pointerEvents: "none",
      }}
    >
      {openChats.map((chat) => {
        const hasLiveStatus = Object.prototype.hasOwnProperty.call(driversStatus, chat.id);
        const liveStatus = hasLiveStatus ? driversStatus[chat.id] : null;
        const status = hasLiveStatus
          ? liveStatus?.isOnline
            ? "online"
            : "offline"
          : chat.driverStatus || "offline";
        const statusLabel = hasLiveStatus
          ? liveStatus?.isOnline
            ? "Online"
            : liveStatus?.lastSeen
            ? `Last seen ${liveStatus.lastSeen}`
            : "Offline"
          : status === "online"
          ? "Online"
          : "Offline";

        return (
        <FloatingChat
          key={chat.key}
          id={chat.key}
          name={chat.name}
          profilePic={chat.profilePic}
          status={status}
          statusLabel={statusLabel}
          messages={chat.messages || []}
          onSendMessage={(msg) => sendMessage(chat.key, msg, chat.type, chat.currentOrder)}
          isMinimized={chat.isMinimized}
          onClose={() => closeChat(chat.key)}
          onToggleMinimize={() => toggleMinimize(chat.key)}
          onLoadMore={() => loadMoreMessages(chat.key)}
          hasMore={!!chat.hasMore}
          style={{ pointerEvents: "auto" }}
          chat={chat}
        />
        );
      })}
    </div>
  );
};

export default ChatManager;
